function Login(props) {
  const p = props;
  return (
    <div className="relative flex min-h-[100dvh] w-full flex-col items-center justify-center bg-slate-100 px-4 py-10 pb-24">
      <div
        className="pointer-events-none absolute inset-0 overflow-hidden"
        aria-hidden="true"
      >
        <div className="absolute -left-32 top-0 h-72 w-72 rounded-full bg-blue-400/20 blur-3xl" />
        <div className="absolute -right-24 bottom-32 h-80 w-80 rounded-full bg-sky-300/25 blur-3xl" />
      </div>

      <div className="relative z-[1] w-full max-w-md">
        <div className="rounded-2xl border border-white/60 bg-white/90 p-8 shadow-lg shadow-slate-900/5 backdrop-blur-md">
          <div className="mb-8 flex flex-col items-center text-center">
            <img
              src={p.logo}
              alt="my.PEACI"
              className={`h-[110px] w-auto object-contain drop-shadow-sm ${
                p.loginLoading ? "animate-bounce" : ""
              }`}
            />
            <h1 className="mt-4 text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
              my.PEACI
            </h1>
            <p className="mt-1 max-w-xs text-sm text-slate-500">
              Sign in with your student ID and password
            </p>
          </div>

          <form className="flex flex-col gap-3" onSubmit={p.onLog} noValidate>
            <label className="sr-only" htmlFor="login-id">
              ID Number
            </label>
            <input
              id="login-id"
              className="peaci-input disabled:bg-slate-50"
              type="number"
              inputMode="numeric"
              placeholder="ID Number"
              onChange={p.idNumInput}
              disabled={p.loginLoading}
              autoComplete="username"
            />
            <label className="sr-only" htmlFor="login-pass">
              Password
            </label>
            <input
              id="login-pass"
              className="peaci-input disabled:bg-slate-50"
              type="password"
              placeholder="Password"
              onChange={p.passInput}
              disabled={p.loginLoading}
              autoComplete="current-password"
            />
            <button
              type="submit"
              className="peaci-btn-primary mt-1 w-full py-3 text-base"
              disabled={p.loginLoading}
            >
              {p.loginLoading ? "Signing in…" : "Sign in"}
            </button>
          </form>

          <div className="mt-6 flex justify-center border-t border-slate-100 pt-6">
            <button
              type="button"
              className="text-sm font-medium text-blue-600 underline-offset-4 hover:text-blue-700 hover:underline"
              onClick={props.loginGsc}
            >
              GSC login
            </button>
          </div>
        </div>
      </div>

      <footer className="fixed bottom-0 left-0 right-0 z-10 border-t border-slate-200/80 bg-slate-900/95 px-3 py-2.5 text-center text-[11px] text-slate-300 backdrop-blur-sm sm:text-xs">
        <span className="text-slate-400">(08/26/26 08:43)</span> Developed by{" "}
        <span className="font-semibold text-white">Mellhabib M. Angni</span>
      </footer>
    </div>
  );
}

export default Login;
